import Router from 'next/router';
import { useCallback } from 'react';

import { BASE_PATH_2_QUERY } from '@glass/common/modules/pages/queryParams';
import compileDynamicUrl from '@glass/common/modules/url/compileDynamicUrl';
import useIdleCallback from '@glass/web/modules/loading/useIdleCallback';
import ResumeBuilderRouter from '@glass/web/modules/resumes/router/ResumeBuilderRouter';

const prefetchedSteps = {};

export const prefetchNextBuilderStep = async (nextStepParams) => {
  const { [BASE_PATH_2_QUERY]: section } = nextStepParams;
  if (!section) {
    return null;
  }

  const pathname = compileDynamicUrl(ResumeBuilderRouter.getResumeBuilderUrl(nextStepParams));

  if (prefetchedSteps[pathname]) {
    return null;
  }

  if (process.env.NEXT_PUBLIC_DEBUG === 'router') {
    console.info('prefetching', pathname);
  }

  prefetchedSteps[pathname] = true;
  return Router.prefetch(pathname);
};

const usePrefetchNextBuilderStep = (nextStepParams) => {
  const handlePrefetchNextBuilderStep = useCallback(
    () => prefetchNextBuilderStep(nextStepParams),
    [nextStepParams],
  );
  useIdleCallback(handlePrefetchNextBuilderStep);
};

export default usePrefetchNextBuilderStep;
